import React from 'react'
import Slider from 'react-slick'

import Configurator from '../../../configurator'
import EventBox from '../../../front/components/shared/events/box'
import classnames from 'classnames'

const CountOfShowSlides = 3

export default class LandingTopEvents extends Configurator {

    render() {
        const {
            events,
            wideScreenSlider,
        } = this.props

        const eventsCount = events ? Object.values(events).length : 0
        const hasFewEvents = eventsCount < CountOfShowSlides
        const slidesToShow = Math.min(eventsCount, CountOfShowSlides)

        const sliderSettings = {
            autoplay: false,
            autoplaySpeed: 10000,
            dots: false,
            infinite: !hasFewEvents,
            slidesToScroll: 1,
            slidesToShow,
            variableWidth: wideScreenSlider,
            speed: 500,
            swipe: false,

            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToScroll: 1,
                        slidesToShow: 2,
                        swipe: true,
                    },
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToScroll: 1,
                        slidesToShow: 1,
                        swipe: true,
                        variableWidth: true,
                    },
                },
            ],
        }

        return (
            <div className={classnames({
                'Landing-blog-slider--top-events': true,
                'Landing-blog-slider--widescreen': wideScreenSlider,
            })}>
                <Slider {...sliderSettings}>
                    {events &&
                        Object.values(events).map((event, index) => (
                            <EventBox
                                key={index}
                                event={event}
                                mainClassName="Events-list"
                            />
                        ))
                    }
                </Slider>
            </div>
        )
    }
}
